export default __webpack_public_path__ + "static/media/Group 6498@3x.b5ad6f2c.png";